import Rest from '../rest'

/******************************************************************************
 *  Tags
 *****************************************************************************/

/**
 * @type {Tag}
 */
export default class Origins extends Rest {

    constructor () {
        super('/origins')
    }

    getOrigins(type = '') {
        return this.getAllV2('', {type: type}).then(response => {
            if (response.data && response.data.status === 'error') return Promise.reject(response)
            let origins = response.data.map(e => {
                return {
                    id: e.id,
                    label: e.label,
                    type: e.type,
                    typeLabel: e.type === 'system' ? 'Sistema' : 'Usuário',
                }
            })

            response.data = origins
            return response
        })
    }
}